import { useBrandStore } from "../stores/brand-store";

export const useBrands = () => {
	const brands = useBrandStore((state) => state.brands);
	const selectedBrand = useBrandStore((state) => state.selectedBrand);
	const createBrand = useBrandStore((state) => state.create);
	const viewBrand = useBrandStore((state) => state.view);
	const indexBrands = useBrandStore((state) => state.index);
	const updateBrand = useBrandStore((state) => state.update);
	const deleteBrand = useBrandStore((state) => state.delete);
	const setSelectedBrand = useBrandStore((state) => state.setSelectedBrand);
	const checkBrandSlugAvailability = useBrandStore((state) => state.checkSlugAvailability);
	const uploadBrandLogo = useBrandStore((state) => state.uploadLogo);
	const deleteBrandLogo = useBrandStore((state) => state.deleteLogo);

	return {
		brands,
		selectedBrand,
		createBrand,
		viewBrand,
		indexBrands,
		showBrand: viewBrand,
		updateBrand,
		deleteBrand,
		setSelectedBrand,
		checkBrandSlugAvailability,
		uploadBrandLogo,
		deleteBrandLogo,
	};
};
